import React from 'react'
import {
    ObjectOverviewSkeletonContainer,
    ObjectOverviewCardLayout,
    ObjectOverviewImageSection,
    ObjectOverviewImageSkeleton,
    ObjectOverviewContentSection,
    ObjectOverviewTitleSection,
    ObjectOverviewBottomRow,
    ObjectOverviewPriceSection,
    SkeletonBox,
} from './styles'

/**
 * Skeleton component matching the ObjectOverviewCard layout (horizontal: image left, content right)
 * Used for loading states in list view listings
 */
const ObjectOverviewCardSkeleton: React.FC = () => {
    return (
        <ObjectOverviewSkeletonContainer>
            <ObjectOverviewCardLayout>
                {/* Image section - left side */}
                <ObjectOverviewImageSection>
                    <ObjectOverviewImageSkeleton />
                </ObjectOverviewImageSection>

                {/* Content section - right side */}
                <ObjectOverviewContentSection>
                    {/* Title section */}
                    <ObjectOverviewTitleSection>
                        {/* Title */}
                        <SkeletonBox $width="80%" $height="3rem" />
                    </ObjectOverviewTitleSection>

                    {/* Stats row */}
                    <SkeletonBox $width="60%" $height="0.875rem" />

                    {/* Rating row */}
                    <SkeletonBox $width="40%" $height="0.875rem" />

                    <SkeletonBox $width="100%" $height="3rem" />

                    {/* Bottom row with price and CTA */}
                    <ObjectOverviewBottomRow>
                        <ObjectOverviewPriceSection>
                            <SkeletonBox $width="120px" $height="3rem" />
                        </ObjectOverviewPriceSection>
                        <SkeletonBox $width="100px" $height="3rem" borderRadius="0.75rem" />
                    </ObjectOverviewBottomRow>
                </ObjectOverviewContentSection>
            </ObjectOverviewCardLayout>
        </ObjectOverviewSkeletonContainer>
    )
}

export default ObjectOverviewCardSkeleton
